export default class DomElementPrinter {
    static async printElement(element) {
        if (!element) {
            return;
        }

        // Get the dimensions of the screen
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;

        const left = (screenWidth - 900) / 2;
        const top = (screenHeight - 600) / 2;

        // Open the window in the center
        const printWindow = window.open('', '_blank', `width=${900},height=${600},top=${top},left=${left}`);
        if (!printWindow) {
            return;
        }

        // Get all stylesheets from the current document
        const stylesheets = Array.from(document.styleSheets);

        // Basic structure to the new window
        printWindow.document.write('<html><head><title>Print</title></head><body></body></html>');

        // Copy all stylesheets to the new window
        stylesheets.forEach(stylesheet => {
            if (stylesheet.href) {
                const linkElement = printWindow.document.createElement('link');
                linkElement.rel = 'stylesheet';
                linkElement.href = stylesheet.href;
                printWindow.document.head.appendChild(linkElement);
            }
            else {
                try {
                    const styleElement = printWindow.document.createElement('style');
                    Array.from(stylesheet.cssRules || []).forEach(rule => {
                        styleElement.appendChild(printWindow.document.createTextNode(rule.cssText));
                    });
                    printWindow.document.head.appendChild(styleElement);
                } catch (e) {
                    // Cross-origin stylesheets can throw when reading cssRules; skip them.
                }
            }
        });

        // Clone the content and append it to the new window
        const clonedContent = element.cloneNode(true);
        printWindow.document.body.appendChild(clonedContent);

        printWindow.document.close();

        // Wait for the content to load before printing
        printWindow.onload = function () {
            printWindow.print();
            // Optional: Close the print window after printing
            printWindow.close();
        };
    }
}